/* eslint-disable no-console */
import {Button, Flex, Progress, Table as TableAnt} from 'antd';
import {ColumnsType} from 'antd/es/table/interface';
import React, {useState} from 'react';

import PilComp from '../../../../../components/DisplayComponent/PilComp';
import {defaultCol} from '../../../../../components/Table/Interface/ITable';
import {stakeholdersTypeKeyLabel} from '../constants/common';

interface DataType {
  key: React.Key;
  id: string;
}

const InfoTable: React.FC<{
  setShowDetails: React.Dispatch<React.SetStateAction<any[]>>;
  dataSource: any;
  stakeholderType: string;
  setProgressFilter: React.Dispatch<React.SetStateAction<any>>;
}> = ({setShowDetails, dataSource, stakeholderType, setProgressFilter}) => {
  const [selectedRow, setSelectedRow] = useState('');
  const stakeholderTitle = stakeholdersTypeKeyLabel.find((item) => {
    return item.value === stakeholderType;
  })?.label;

  const columns: Array<defaultCol & ColumnsType<DataType>[0]> = [
    {
      dataIndex: 'name',
      title: stakeholderTitle
      // width: 200
    },
    {
      dataIndex: 'status',
      title: 'Data Status',
      // width: 150,
      render: (value) => {
        const color =
          value === 'Not Started'
            ? '#8BA7B8'
            : value === 'In Progress'
              ? '#98F2E1'
              : '#BFE6AC';

        return <PilComp color={color} value={value} />;
      }
    },
    {
      dataIndex: 'percentage',
      title: 'Progress Trackers',
      // width: 300,
      render: (value) => {
        return (
          <Flex vertical>
            <div
              style={{
                alignSelf: 'flex-end',
                color: '#2E2A2A',
                textAlign: 'right',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '120%'
              }}
            >
              {!isNaN(value) ? `${value}%` : '0%'}
            </div>
            <Progress
              percent={value}
              showInfo={false}
              trailColor="#B1C4CF"
              strokeColor="#024064"
            />
          </Flex>
        );
      }
    },
    {
      dataIndex: 'action',
      title: 'Details',
      // width: 200,
      render: (_, record: any) => {
        return (
          <Button
            type="default"
            onClick={() => {
              setShowDetails(record?.data ?? []);
              setSelectedRow(record?._id);
              setProgressFilter(record ?? undefined);
            }}
          >
            Details
          </Button>
        );
      }
    }
  ];

  return (
    <div
      style={{
        flex: '1',
        borderRadius: '8px',
        border: '1px solid #D2D4DA',
        padding: '14px 15px',
        maxHeight: '280px',
        overflowY: 'hidden'
      }}
    >
      <TableAnt
        // getPopupContainer={(triggerNode) =>
        //   triggerNode.closest(
        //     '.ant-modal, .ant-drawer, [style*="position"]'
        //   ) as HTMLElement
        // }
        rowKey="_id"
        className="stakeInfoTable"
        rowSelection={{
          selectedRowKeys: [selectedRow],
          hideSelectAll: true,
          preserveSelectedRowKeys: false,
          onChange: (selectedKey: React.Key[], selectedRow: any[]) => {
            if (selectedRow.length === 1) {
              setSelectedRow(selectedRow?.[0]?._id ?? '');
              setShowDetails(selectedRow?.[0]?.data ?? []);
              setProgressFilter(selectedRow?.[0] ?? undefined);
            } else {
              setSelectedRow(selectedRow?.[1]?._id ?? '');
              setShowDetails(selectedRow?.[1]?.data ?? []);
              setProgressFilter(selectedRow?.[1] ?? undefined);
            }
          }
        }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        style={{width: '100%'}}
        scroll={{
          y: 200
        }}
      />
    </div>
  );
};

export default InfoTable;
